module.exports = __webpack_public_path__ + "static/media/aclive_umb_logo.50ac92f3.svg";